module.exports = __webpack_public_path__ + "static/media/galdinsWon_100_250.937aeb42.png";